import api from '@/services/index.js'
import { nameBankArray } from '@/services/modules/Bank.services.js'

async function fetchDeposit(callback) {
  await api
    .get('/user-profile-composite/v1/history/deposit')
    .then((v) => {
      if (v.success == true) {
        var tran = v.data.Transaction.filter(
          (x) =>
            x.TransType == 'DEPOSIT' ||
            x.TransType == 'AFFILIATE' ||
            x.TransType == 'CASHBACK'
        )

        callback({ status: true, data: tran, message: '' })

        // var tranAll = v.data.Transaction.filter(
        //   (x) =>
        //     x.TransType == 'DEPOSIT' ||
        //     x.TransType == 'AFFILIATE' ||
        //     x.TransType == 'CASHBACK' ||
        //     x.TransType == 'WITHDRAW'
        // )
      } else {
        callback({ status: false, data: '', message: v.message })
      }
    })
    .catch((e) => {
      callback({ status: false, data: '', message: e.message })
    })
    .finally(() => {})
}
async function fetchBank(callback) {
  await api
    .get('/user-profile-composite/v1/info/deposit')
    .then((v) => {
      if (v.success == true) {
        let newdateTrue = []
        let newdate = []
        let newAuto = []
        v.data.forEach((element) => {
          if (element.BankCode == undefined) {
            element.Channel = 'co.th.truemoney.wallet'
            element['BankCode'] = 'co.th.truemoney.wallet'
            element['BankAccount'] = element.phoneNumber
            element['BankAccount'] = element.phoneNumber
            element['BankName'] = 'ทรูมันนี่วอเล็ท'
            newdateTrue.push(element)
            newdate.push(element)
          } else {
            element['BankName'] = nameBankArray[element.BankCode]
            newAuto.push(element)
            newdate.push(element)
          }
        })
        callback({
          status: true,
          data: {
            ChBankTrue: newdateTrue,
            ChAuto: newAuto,
            All: newdate,
          },
          message: '',
        })
        // this.calculateDeposit(0)
        /*this.ChList.push({
        ImgUrl: "/static/img/bank/tmn_voucher.png?v2",
        Channel: "co.th.truemoney.wallet.gift",
        bank_name: "ทรูมันนี่วอเล็ท (Gift URL)",
      });*/
      } else {
        callback({ status: false, data: '', message: v.message })
      }
    })
    .catch((e) => {
      callback({ status: false, data: '', message: e.message })
    })
    .finally(() => {})
}

export { fetchDeposit, fetchBank }



// WEBPACK FOOTER //
// ./src/services/modules/deposit.js